/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppleAppSiteAssociationController } from '../models/AppleAppSiteAssociationController';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AppleAppSiteAssociationControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a AppleAppSiteAssociationController resource.
     * Retrieves a AppleAppSiteAssociationController resource.
     * @returns AppleAppSiteAssociationController AppleAppSiteAssociationController resource
     * @throws ApiError
     */
    public apiDeepLinkingappleAppSiteAssociationGet(): CancelablePromise<AppleAppSiteAssociationController> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/deep-linking/apple-app-site-association',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
